import { render, staticRenderFns } from "./wrongBookDetails.vue?vue&type=template&id=377e61ec&scoped=true"
import script from "./wrongBookDetails.vue?vue&type=script&lang=js"
export * from "./wrongBookDetails.vue?vue&type=script&lang=js"
import style0 from "./wrongBookDetails.vue?vue&type=style&index=0&id=377e61ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377e61ec",
  null
  
)

export default component.exports